interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-search-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center text-center py-16 md:py-20 px-4">
      <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-5">
        <i className={`${icon} text-3xl md:text-4xl`}></i>
      </div>
      <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
        {title}
      </h3>
      {description && (
        <p className="mt-2 max-w-md text-sm text-foreground-500 leading-relaxed">
          {description}
        </p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-accent-600 cursor-pointer"
        >
          <i className="ri-refresh-line text-base"></i>
          {actionLabel}
        </button>
      )}
    </div>
  );
}